export const isOnlyDigits = (str) => str && !/\D/.test(str);
//# sourceMappingURL=isOnlyDigits.js.map